var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
        'busy': _vm.isJoining,
    },on:{"click":_vm.joinCourse}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }